// After Auth0 returns to apply Contact, resume only when both Sign-in
// snapshots are still present. SIGN_IN always writes the form values and
// the lookup response together. Either leftover alone is stale: lookup-only
// is what NewMember used to leave after clearing the form; form-only is
// partial browser state and must not attach via dashboard prefill.
function shouldResumePostLoginAttach({
  disableEmail = false,
  savedFormValues = null,
  resumedExistingContact = null,
}) {
  return !!disableEmail && !!savedFormValues && !!resumedExistingContact
}

export default shouldResumePostLoginAttach
